import {CreateAbility, MongoAbility, createMongoAbility} from '@casl/ability';
import {AccountImageSubject, AccountSubject, DynamicResourceSubject, RoleSubject, StubSubject} from './common-subjects';

export type CRUD = 'create' | 'read' | 'update' | 'delete';
export type CRU = Exclude<CRUD, 'delete'>;

// Define strict action-subject combinations for compile-time validation
export type CommonAbilities =
  // Role Management domain
  | [CRUD | 'manage', RoleSubject]
  // Dynamic Resource domain
  | [CRUD | 'manage', DynamicResourceSubject]
  // Account domain
  | [CRUD | 'manage' | 'assignRole', AccountSubject]
  // Account Image domain
  | [CRUD | 'manage', AccountImageSubject]
  // Stub for tests and special cases
  | ['stubAction', StubSubject]

  // Special 'all' for admin
  | ['manage', 'all'];

export type CommonAbility = MongoAbility<CommonAbilities>;

// ✅ Create typed ability factory for type-safe builder
export const createCommonAbility = createMongoAbility as CreateAbility<CommonAbility>;
